import React from "react";
import { styles } from "./SimpleFeatureListWidget.styles";
import { Element, IElementProps } from "../components/Element/Element";
import { LinkButton } from "../../../elements/LinkButton";

export interface IFeatureListWidgetProps {
  title: string;
  elements: IElementProps[];
  handleOnClick?: React.MouseEventHandler;
  ctaText?: string;
  ctaUrl?: string;
  ctaOnClick?: React.MouseEventHandler;
}

export function SimpleFeatureListWidget({
  title,
  elements,
  handleOnClick,
  ctaText,
  ctaUrl,
  ctaOnClick,
}: IFeatureListWidgetProps) {
  const renderButton = () => {
    return (
      <div className={styles.ctaWrapper()}>
        <LinkButton href={ctaUrl} onClick={ctaOnClick}>
          {ctaText}
        </LinkButton>
      </div>
    );
  };

  return (
    <div className={styles.root()}>
      <h2>{title}</h2>
      <ul>
        {elements.map((element) => (
          <Element key={`bulletpoint-${element.name}`} {...{ href: element.url, onClick: handleOnClick, ...element }} />
        ))}
      </ul>
      {ctaText && renderButton()}
    </div>
  );
}
